import { Document } from 'yaml';
import type { TrackDefinition } from '@internal/backstage-plugin-pulse-common';
import { downloadYaml } from '../yaml-export';

const RUNTIME_ONLY_FIELDS = ['source', 'createdAt', 'updatedAt'];

const toAuthoredTrack = (track: TrackDefinition): Record<string, unknown> => {
  const definition = { ...track } as Record<string, unknown>;
  for (const field of RUNTIME_ONLY_FIELDS) {
    delete definition[field];
  }
  return definition;
};

/** Serialises track definitions to the same list shape as pulse/tracks YAML. */
export const tracksToYaml = (tracks: TrackDefinition[]): string =>
  new Document(tracks.map(toAuthoredTrack)).toString({ lineWidth: 80 });

/** Serialises a single track as a single-item YAML list. */
export const trackToYaml = (track: TrackDefinition): string =>
  tracksToYaml([track]);

/** Triggers a browser download of the authored track YAML. */
export const downloadTrackYaml = (track: TrackDefinition): void =>
  downloadYaml(`${track.id}.yaml`, trackToYaml(track));

/** Triggers a browser download of all given tracks as one YAML file. */
export const downloadTracksYaml = (tracks: TrackDefinition[]): void =>
  downloadYaml('tracks.yaml', tracksToYaml(tracks));
